import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmailAdmin from './email-admin.reducer';

export const selectEmailAdminState = createFeatureSelector<fromEmailAdmin.State>(fromEmailAdmin.emailAdminFeatureKey);

export const selectIsSending = createSelector(selectEmailAdminState, (state) => state.isSending);
export const selectIsSuccess = createSelector(selectEmailAdminState, (state) => state.isSuccess);
export const selectError = createSelector(selectEmailAdminState, (state) => state.error);
